export const PermissionsState = Object.freeze({
  GRANTED: 'granted',
  DENIED: 'denied',
  PROMPT: 'prompt',
  UNKNOWN: 'unknown',
  UNSUPPORTED: 'unsupported',
});
